<template>
  <article class="problem-solution-card card">
    <h3>{{ icon }} Problem: {{ title }}</h3>
    <p><strong>Symptoms:</strong> {{ symptoms }}</p>
    <p><strong>Solutions:</strong></p>
    <ol>
      <li v-for="(step, i) in solutions" :key="i">{{ step }}</li>
    </ol>
  </article>
</template>

<script>
export default {
  name: 'ProblemSolutionCard',
  props: {
    icon: { type: String, default: '🔧' },
    title: { type: String, required: true },
    symptoms: { type: String, required: true },
    solutions: { type: Array, required: true },
  },
};
</script>
